import React from "react";

export const RouteTemplate = React.forwardRef(({ routeData }, ref) => {

    return (
        <div
        ref={ref}
        style={{
            padding: "10px",
            background: "#fff",
        }}
        >
            <table
                width="100%"
                style={{
                borderCollapse: "collapse",
                fontSize: "12px",
                }}
            >
                <thead>
                <tr>
                    <th style={{ border: "1px solid #000", padding: "5px 10px" }}>S.No</th>
                    <th style={{ border: "1px solid #000", padding: "5px  10px" }}>Zone</th>
                    <th style={{ border: "1px solid #000", padding: "5px  10px" }}>Route</th>
                    <th style={{ border: "1px solid #000", padding: "5px  10px" }}>Place</th>
                </tr>
                </thead>

                <tbody>
                {routeData?.length > 0 ? (
                    routeData.map((data, index) => (
                    <tr key={index}>
                        <td style={{ border: "1px solid #000", padding: "5px  10px", textAlign: "center" }}>
                        {index + 1}
                        </td>

                        <td style={{ border: "1px solid #000", padding: "5px  10px" }}>
                        {data.zone}
                        </td>

                        <td style={{ border: "1px solid #000", padding: "5px  10px" }}>
                        {data.route?.map((r, i) => (
                            <div key={i}>{r.route}</div>
                        ))}
                        </td>

                        <td style={{ border: "1px solid #000", padding: "5px  10px" }}>
                        {data.route?.map((r) =>
                            r.place?.map((p, i, arr) => (
                            <span key={i} style={{marginRight: '5px'}}>
                                {p.location}
                                {i < arr.length - 1 ? ", " : ""}
                            </span>
                            ))
                        )}
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan={4} style={{ textAlign: "center", padding: "10px" }}>
                        No Route Data
                    </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
});
